export const MODAL_SET_ON_PROTECTION_TEXT = {
	confirmBtn: 'Confirm',
	setOnProtectionTitle: 'Set on protection',
	protectionDetails: 'Protection details',
	setOnProtectionDescription:
		'Specify the protection location and and time of this activity for the driver.',
	closeBtn: 'Close',
	cancelBtn: 'Cancel',
	startDateAndTime: 'Start date and time',
	endDateAndTime: 'End date and time',
	location: 'Location',
	fromLocation: 'From location is required',
};
